module.exports = __webpack_public_path__ + "paper_bag_design_rvcnn_packaging_design_rovcanin_fashion_jewellery.jpg?c1d2e178185a2754cb91f116c29d59db";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/paper_bag_design_rvcnn_packaging_design_rovcanin_fashion_jewellery.jpg
// module id = 97
// module chunks = 0